import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { mmYYYY } from "@/lib/money";

export default function StockView() {
  const [product, setProduct] = useState("");
  const [location, setLocation] = useState("");
  const [rows, setRows] = useState([]);
  const [locations, setLocations] = useState([]);
  useEffect(() => { api.get("/inventory/locations").then((r) => setLocations(r.data)); }, []);
  useEffect(() => {
    const c = new AbortController();
    const t = setTimeout(() => api.get("/inventory/stock", { params: { product, location }, signal: c.signal }).then((r) => setRows(r.data)).catch((e) => !c.signal.aborted && toast.error(errMsg(e))), 250);
    return () => { clearTimeout(t); c.abort(); };
  }, [product, location]);
  const total = rows.reduce((a, r) => a + r.qty, 0);
  return (
    <div className="space-y-3" data-testid="stock-view">
      <div className="flex flex-wrap gap-2">
        <input value={product} onChange={(e) => setProduct(e.target.value)} placeholder="Product or barcode" className="h-11 flex-1 rounded-xl border border-slate-200 bg-white px-3 text-sm" data-testid="stock-filter-product" />
        <select value={location} onChange={(e) => setLocation(e.target.value)} className="h-11 rounded-xl border border-slate-200 bg-white px-2 font-mono text-sm" data-testid="stock-filter-location">
          <option value="">All locations</option>
          {locations.map((l) => <option key={l.id} value={l.id}>{l.code}</option>)}
        </select>
      </div>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full min-w-[640px] text-left text-sm" data-testid="stock-table">
          <thead className="bg-slate-50 font-mono text-[10.5px] uppercase tracking-wider text-slate-500">
            <tr><th className="px-3 py-2">Product</th><th className="px-3 py-2">Location</th><th className="px-3 py-2">Batch</th><th className="px-3 py-2">Expiry</th><th className="px-3 py-2">Received</th><th className="px-3 py-2 text-right">Qty</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id} data-testid={`stock-row-${r.id}`}>
                <td className="px-3 py-2.5 font-semibold text-slate-900">{r.product_name}</td>
                <td className="px-3 py-2.5"><span className="rounded bg-slate-900 px-1.5 py-0.5 font-mono text-xs text-amber-400">{r.location_code}</span></td>
                <td className="px-3 py-2.5 font-mono text-xs">{r.batch_no || "—"}</td>
                <td className="px-3 py-2.5 font-mono text-xs">{r.expiry ? mmYYYY(r.expiry) : "—"}</td>
                <td className="px-3 py-2.5 font-mono text-xs">{r.received_at.startsWith("1970") ? "before inventory" : r.received_at.slice(0, 10)}</td>
                <td className={`px-3 py-2.5 text-right font-mono font-bold ${r.qty < 0 ? "text-rose-600" : ""}`} data-testid={`stock-qty-${r.id}`}>{r.qty}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr className="border-t border-slate-200 bg-slate-50"><td colSpan={5} className="px-3 py-2 text-xs font-bold uppercase text-slate-500">{rows.length} lots</td><td className="px-3 py-2 text-right font-mono font-bold" data-testid="stock-total">{total}</td></tr></tfoot>
        </table>
      </div>
    </div>
  );
}
